import { Component } from '@angular/core';

@Component({
  selector: 'app-no-instance-found',
  templateUrl: './no-instance-found.component.html',
  styleUrls: ['./no-instance-found.component.scss']
})
export class NoInstanceFoundComponent {
}
